import { type FilledTextFieldProps, TextField } from '@mui/material';
import React from 'react';

import CLocalizedText from './CLocalizedText';

export interface CustomTextFieldProps extends Omit<FilledTextFieldProps, 'variant'> {
  onEnter?: () => void;
}

/***
 * Textfield wrapper to enforce the 'filled' variant.
 * @param props one or more properties of TextFieldProps
 * @constructor
 */
export default function CustomTextField(props: CustomTextFieldProps) {
  return (
    <TextField
      fullWidth
      {...props}
      value={props.value ?? ''}
      variant={props.label ? 'filled' : 'outlined'}
      InputLabelProps={{ required: false }}
      inputProps={{
        'aria-required': props.required ? true : undefined
      }}
      label={
        props.label && (
          <>
            {props.label}
            {props.required && (
              <span aria-hidden="true">
                {' '}
                (<CLocalizedText dictKey="textField.label.required" />)
              </span>
            )}
          </>
        )
      }
      onKeyDown={(ev) => {
        props.onKeyDown?.(ev);

        if (ev.key === 'Enter') {
          props.onEnter?.();
          if (!props.onKeyDown) (document.activeElement as HTMLElement).blur();
        }
      }}
    />
  );
}
